module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 10 Farma Pasa - Tramak.efbf38ec.mp3";